import {Dispatch} from 'redux';
import {DATETABS_SET_TYPE} from 'store/actionTypes';
import {DateTabsType} from 'utils/types';
import {DateTabsSetTypeAction} from '../types';

// TODO: documentation

const setDateTabsType = (tabsType: DateTabsType) => (
  dispatch: Dispatch<DateTabsSetTypeAction>,
): void => {
  dispatch({
    type: DATETABS_SET_TYPE,
    payload: {tabsType},
  });
};

export default setDateTabsType;
